module.exports = __webpack_public_path__ + "static/media/79488e1a-fda7-4b81-b53c-5b4f07733cf5.bf3b85e4.jpeg";